// extracted by mini-css-extract-plugin
module.exports = {"seccion":"styles_seccion__zMwTf"};